(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accio-engineering-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-accio-section="engineering-showcase"]');
    if (!sections.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduceMotion) return;

    var MAX_SHIFT = 0.13;
    var nodes = [];
    var ticking = false;

    function measure() {
      nodes = [];
      sections.forEach(function (section) {
        var media = section.querySelector('.accio-eng__media');
        if (!media) return;
        nodes.push({ section: section, media: media });
      });
    }

    function render() {
      ticking = false;
      var viewport = window.innerHeight || 0;

      nodes.forEach(function (node) {
        var rect = node.section.getBoundingClientRect();
        if (rect.bottom < -viewport * 0.5 || rect.top > viewport * 1.5) return;

        var progress = (viewport - rect.top) / (viewport + rect.height);
        if (progress < 0) progress = 0;
        if (progress > 1) progress = 1;

        var span = (viewport + rect.height) * MAX_SHIFT;
        var offset = (progress - 0.5) * span;

        node.media.style.setProperty('--accio-eng-parallax', offset.toFixed(2) + 'px');
      });
    }

    function request() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(render);
    }

    measure();
    render();

    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', function () {
      measure();
      request();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accio-process"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('[data-accio-section="process"]');
    if (!sections.length) return;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initProgress(section) {
      var grid = section.querySelector('.accio-proc__grid');
      if (!grid) return;

      if (reduceMotion || !('IntersectionObserver' in window)) {
        grid.classList.add('is-lively');
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-lively');
              observer.unobserve(entry.target);
            }
          });
        },
        { rootMargin: '0px 0px -12% 0px', threshold: 0.15 }
      );

      observer.observe(grid);
    }

    function initParallax(section) {
      if (reduceMotion) return;

      var rect = null;
      var frame = null;

      function measure() {
        rect = section.getBoundingClientRect();
      }

      function apply() {
        frame = null;
        if (!rect) measure();
        if (!rect) return;

        var viewport = window.innerHeight || 0;
        if (rect.bottom < -viewport * 0.5 || rect.top > viewport * 1.5) return;

        var progress = (viewport - rect.top) / (viewport + rect.height);
        var clamped = Math.max(0, Math.min(1, progress));
        var offset = (clamped - 0.5) * 56;

        section.style.setProperty('--accio-proc-parallax', offset.toFixed(2) + 'px');
      }

      function onScroll() {
        if (frame) return;
        frame = window.requestAnimationFrame(apply);
      }

      function onResize() {
        rect = null;
        onScroll();
      }

      measure();
      apply();
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onResize, { passive: true });
    }

    Array.prototype.forEach.call(sections, function (section) {
      initProgress(section);
      initParallax(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  // Desktop mega menu: the disclosure is opened by hover so the panel behaves
  // like a hover menu, while <details> keeps its native click/keyboard behaviour.
  // Listeners stay on `document` because the header section can be re-rendered.
  class MegaMenuHover {
    constructor() {
      this.hoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
      this.closeDelay = 140;
      this.closeTimers = new WeakMap();
      this.onPointerOver = this.onPointerOver.bind(this);
      this.onPointerOut = this.onPointerOut.bind(this);
      this.onClick = this.onClick.bind(this);

      document.addEventListener('mouseover', this.onPointerOver);
      document.addEventListener('mouseout', this.onPointerOut);
      document.addEventListener('click', this.onClick);
    }

    menuFor(node) {
      if (!(node instanceof Element)) return null;
      const menu = node.closest('.header__inline-menu details.mega-menu');
      return menu instanceof HTMLDetailsElement ? menu : null;
    }

    isInside(menu, node) {
      return node instanceof Node && menu.contains(node);
    }

    cancelClose(menu) {
      const timer = this.closeTimers.get(menu);
      if (timer === undefined) return;
      window.clearTimeout(timer);
      this.closeTimers.delete(menu);
    }

    open(menu) {
      this.cancelClose(menu);
      document.querySelectorAll('.header__inline-menu details.mega-menu[open]').forEach((other) => {
        if (other !== menu) other.removeAttribute('open');
      });
      menu.setAttribute('open', '');
    }

    close(menu) {
      this.cancelClose(menu);
      this.closeTimers.set(
        menu,
        window.setTimeout(() => {
          this.closeTimers.delete(menu);
          // Never hide a panel that still owns focus (keyboard users).
          if (menu.contains(document.activeElement)) return;
          menu.removeAttribute('open');
        }, this.closeDelay)
      );
    }

    onPointerOver(event) {
      if (!this.hoverQuery.matches) return;
      const menu = this.menuFor(event.target);
      if (!menu || this.isInside(menu, event.relatedTarget)) return;
      this.open(menu);
    }

    onPointerOut(event) {
      if (!this.hoverQuery.matches) return;
      const menu = this.menuFor(event.target);
      if (!menu || this.isInside(menu, event.relatedTarget)) return;
      this.close(menu);
    }

    onClick(event) {
      // A mouse click only happens while the pointer already sits inside the
      // disclosure, so hover owns the state: stop the native toggle from closing
      // what hover just opened. Keyboard activation (detail 0) still toggles.
      if (!this.hoverQuery.matches || event.detail === 0) return;
      const menu = this.menuFor(event.target);
      if (!menu) return;
      const summary = menu.querySelector('summary');
      if (!summary || !summary.contains(event.target)) return;
      event.preventDefault();
      summary.setAttribute('aria-expanded', 'true');
    }
  }

  new MegaMenuHover();

  } catch(e) { console.error(e); }
})();
})();
